<div class="hotel-list">
  <div class="hotel-list__header">
    <h2>{{ cityName }} Hotels</h2>

    @if (!isFetching) {
      <button (click)="seeAll($event)" class="hotel-list__see-all">
        See all
      </button>
    }
  </div>

  <div class="hotel-list__content">
    @if (isFetching) {
      <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
        <div class="swiper-wrapper">
          @for (hotel of [1, 2, 3, 4]; track hotel; let idx = $index) {
            <div class="swiper-slide">
              <app-hotel-card-mobile
                [isFetching]="isFetching"
              ></app-hotel-card-mobile>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
        <div class="swiper-wrapper">
          @for (hotel of hotels | slice: 0 : 16; track hotel.id) {
            <div class="swiper-slide">
              <app-hotel-card-mobile
                [hotel]="hotel"
                [countryName]="countryName"
                [cityName]="cityName"
                [cityId]="cityId"
              ></app-hotel-card-mobile>
            </div>
          }
        </div>
      </div>
    }
    @if (!isFetching && !hotels.length) {
      <app-no-items-found title="EMPTY.HOTELS"></app-no-items-found>
    }
  </div>
</div>
